module.exports = __webpack_public_path__ + "static/img/banner.89170b74.jpg";